<template>
  <v-card>
    <v-card-title>
      <span class="title">Change</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <form @submit.prevent="formSubmit">

        <v-text-field
          v-model="company.company_code"
          label="Company code"
          :error-messages="errors.collect('company code')"
          v-validate="'required|max:4'"
          data-vv-name="company code"
          required
          :counter="4"
        ></v-text-field>

        <v-text-field
          v-model="company.description"
          label="Description"
          :error-messages="errors.collect('description')"
          v-validate="'required'"
          data-vv-name="description"
          required
        ></v-text-field>

        <v-btn @click="formSubmit" dark color="accent" :loading="getLoading" :disable="getLoading">update</v-btn>
        <v-btn to="/company">cancel</v-btn>
      </form>
    </v-card-text>

    <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat dark @click.native="snackbar = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'change-company',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      id: this.$route.params.id,
      company: {},
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    }
  },
  methods: {
    ...mapActions(['changeCompany', 'setActiveCompany']),
    /**
     *
     */
    formSubmit: function () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.changeCompany(this.company)
            .then(() => {
              let response = this.getResponse
              this.snackbar = true
              this.text =
                response.status === 200
                  ? 'Changed successfully.'
                  : response.data.message
              this.color = response.status === 200 ? 'success' : 'error'
            })
            .catch(error => {
              console.log(error)
            })
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getResponse', 'getActiveCompany', 'getLoading'])
  },
  mounted: function () {
    this.setActiveCompany(this.id)
      .then(() => {
        this.company = Object.assign({}, this.getActiveCompany)
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style scoped>
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/company/ChangeCompany.vue